global.$ = global.jQuery = require('jquery');

import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

import Headroom from "headroom.js";

import AOS from 'aos';
import 'aos/dist/aos.css';

import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
window.Swiper = Swiper;
$(document).ready(function() {

    $(function() {
        AOS.init({
            duration: 600,
            mirror: true,
            once: true,
        });
    });

    // To-top button
    const toTopBtn = $('#to-top');
    toTopBtn.on('click', function (e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: 0
        }, 'fast');
    });

    const closerX = $('#closerX-box');
    // sticky scroll menu
    const header = $('header');
    let offSet = $('.home-background-video').innerHeight()
    let fromTop = ($(window).scrollTop())
    // let beforeAfterImg =$('.box-before-after .img');
    // beforeAfterImg.css('background-size' , $(".box-before-after").width()+'px')
    window.onresize = function() {
        offSet = $('.home-background-video').innerHeight()
        // beforeAfterImg.css('background-size' , $(".box-before-after").width()+'px')
        setHead()
    }
    setHead()
    function setHead(){
        header.removeClass('header--std');
        if (header.attr('data-type') === 'header--home') {
            if (fromTop >= offSet){
                header.removeClass(header.attr('data-type'));
            } else {
                header.addClass(header.attr('data-type'));
            }
            window.onscroll = function () {
                fromTop = ($(window).scrollTop())
                if (fromTop >= offSet){
                    header.removeClass(header.attr('data-type'));
                    header.addClass('header--std');
                } else {
                    header.addClass(header.attr('data-type'));
                    header.removeClass('header--std');
                }
            };
        } else {
            header.addClass('header--std');
        }
    }

    if($('.headroom').length > 0){
        let headroomEl = document.querySelector("header");
        let options = {
            offset : 100,
        }
        let headroom  = new Headroom(headroomEl,options);
        headroom.init();
    }

    closerX.click(function (e) {
        toggleMenuOpenClose();
    })

    // burger menu effect button
    let burgerButton = $('.burger-button');
    burgerButton.on('click', function(e) {
        e.preventDefault();
        toggleMenuOpenClose();
    });

    function toggleMenuOpenClose() {
        let body = $('body');
        let headerNavWrapper = $('.header__nav-wrapper');
        if (headerNavWrapper.hasClass('open')) {
            body.removeClass('no-scroll-y');
            headerNavWrapper.removeClass('open');
        } else {
            body.addClass('no-scroll-y');
            headerNavWrapper.addClass('open');
        }
        $('#burger-button i').toggleClass("fa-bars fa-x");
    }

    let img_activer = $('.img-activer');
    img_activer.on('mouseenter', function (e) {
        e.stopPropagation();
        let img = $('#'+$(this).data('code'))
        let images = $('.menu_img');
        images.removeClass('visible')
        img.addClass('visible')
    })

    $('.accordion-collapse').on('shown.bs.collapse', function (e) {
        let $panel = $(this).closest('.accordion-item');
        $('html,body').animate({
            scrollTop: $panel.offset().top - 100
        }, 200);
    });

    // PAGE SALOON LOCATOR MAPS // -------------------------------------------
    if ($('.page-saloon_locator').length){
        let locations = [

            [0,'DNA sede', 'Via Antonio Meucci, 4, 30035 Mirano VE', {lat: 45.49307090505629, lng: 12.077862212712343}],
            [1,'Noi Donne','Via Lungo Tanaro Magenta, 3 15121 Alessandria AL', {lat: 44.9108899, lng: 8.6147747}],
            [2,'Franzosi Rita','Via Brigata Tortona, 16 15057 Tortona AL', {lat: 44.8935406, lng: 8.8564783}],
            [3,'L\' Angolo di Roberta Acconciature','Piazza Pertini, 11 40052 Baricella BO', {lat: 44.6467099, lng: 11.5348266}],
            [4,'Salon Sigrid','Via Tre Santi, 1/B 39100 Bolzano BZ', {lat: 46.5002360, lng: 11.3360253}],
            [5,'Salone Tini','Via Merano 44 39018 Vilpiano di Terlano BZ', {lat: 46.5600877, lng: 11.2239200}],
            [6,'Vanity Hair','Via Xxv Aprile,22/a 26030 Casteldidone CR', {lat: 45.0702345, lng: 10.4062719}],
            [7,'Fabrizio Hair Team','Via del Progresso, 7 26010 Corte de\'Frati CR', {lat: 45.2207947, lng: 10.0939710}],
            [8,'Pin-Up Parrucchieri','Piazza Xx Settembre,8 44015 Portomaggiore FE', {lat: 44.6982351, lng: 11.8073468}],
            [9,'Armonia','Via Garibaldi 11/a 44049 Vigarano Mainarda FE', {lat: 44.8416741, lng: 11.4952154}],
            [10,'Le Teste Matte','Via San Ferolo,3/D 26900 Lodi LO', {lat: 45.3106144, lng: 9.5010085}],
            [11,'Acconciature Claudia','Via Belfiore, 37Bis 46012 Bozzolo MN', {lat: 45.1044900, lng: 10.4779282}],
            [12,'Amethyst Hair & Beauty','Via Radici in Piano,46 41049 Sassuolo MO', {lat: 44.5464779, lng: 10.7869247}],
            [13,'I Costanzo','Via C. Battisti, 6 H/G 29013 Carpaneto Piacentino PC', {lat: 44.9037971, lng: 9.7922059}],
            [14,'Sisters','Strada del Santo,71 35010 Cadoneghe PD', {lat: 45.4808830, lng: 11.8995380}],
            [15,'Salone Marisa','Via Antoniana, 220 H 35011 Campodarsego PD', {lat: 45.5083880, lng: 11.9093701}],
            [16,'Salone Sabrina','Via Madonna delle Grazie 39 35012 Camposampiero PD', {lat: 45.5709286, lng: 11.9318628}],
            [17,'Visavì','Via Abate l. Barbo 8 35020 Correzzola PD', {lat: 45.2353821, lng: 12.0677625}],
            [18,'Salone Hair B','Via de Gasperi,39 Loc.Pieve 35010 Curtarolo PD', {lat: 45.5187010, lng: 11.8313461}],
            [19,'Serena Idee per la Testa','Piazza Europa 10 35010 Curtarolo PD', {lat: 45.5230903, lng: 11.8327040}],
            [20,'Backstage','Via Principe Amedeo, 29 35042 Este PD', {lat: 45.2238194, lng: 11.6618092}],
            [21,'Life Acconciature','Via Ca\' Onorai,30/a 35015 Galliera Veneta PD', {lat: 45.6674644, lng: 11.8105376}],
            [22,'Salone Diana','Via T.Vecellio 115 35132 Padova PD', {lat: 45.2136533, lng: 11.8347574}],
            [23,'Sebastian & Giuseppe','Via Cittadella 4 35137 Padova PD', {lat: 45.4101512, lng: 11.8777149}],
            [24,'L\'Angolo dei Capelli','Via S. Francesco 8 /a 35030 S.Domenico Selvazzano PD', {lat: 45.3876954, lng: 11.8014373}],
            [25,'Emme Style','Via Montello Secondo Tronco, 60/C 35010 Silvelle-Trebaseleghe PD', {lat: 45.6056304, lng: 12.0475184}],
            [26,'Debora e Simona','Via S.Ambrogio 80/a 35010 Trebaseleghe PD', {lat: 45.5957622, lng: 12.0810835}],
            [27,'Salone Donna Più','Via Roma 70/D 35010 Villafranca Padovana PD', {lat: 45.4736937, lng: 11.8122239}],
            [28,'Idee Nuove','Via 4 Novembre, 5 35030 Vo\' Euganeo PD', {lat: 45.3342661, lng: 11.6408956}],
            [29,'Acconciature Cristina','Via S.Rocco, 90 43052 Colorno PR', {lat: 44.9244602, lng: 10.3719901}],
            [30,'Parrucchiera Mariangela','Via Lisoni, 8/C 43100 Parma PR', {lat: 44.7920434, lng: 10.3551047}],
            [31,'Beatrice Acconciature Unisex','Viale Indipendenza, 1/a 43039 Salsomaggiore Terme PR', {lat: 44.8178546, lng: 9.9864484}],
            [32,'Collage','Via Trento, 76 27049 Stradella PV', {lat: 45.0755363, lng: 9.2996492}],
            [33,'Salone Patrizia','Via Martiri Partigiani, 40 27049 Stradella PV', {lat: 45.0775418, lng: 9.3006074}],
            [34,'Nuova Immagine','Via Bobbio 24/D 27058 Voghera PV', {lat: 44.9922839, lng: 9.0073938}],
            [35,'Vanity','Piazza 25 Aprile, 3/B 42021 Barco di Bibbiano RE', {lat: 44.6880928, lng: 10.4930142}],
            [36,'Rituali di Bellezza','Via Adrianova, 6 45011 Adria RO', {lat: 45.0532035, lng: 12.0562547}],
            [37,'Un\'Idea per la Testa','Via Boscolo,24 45100 Rovigo RO', {lat: 45.0699458, lng: 11.7941386}],
            [38,'Kontatto Parrucchieri','Via Feltrina Centro 64/B 31044 Biadene di Montebelluna TV', {lat: 45.7902710, lng: 12.0467625}],
            [39,'I Riccioli di Laura','Via Montegrappa 41/2 31050 Camalo\' di Povegliano TV', {lat: 45.7519328, lng: 12.1702049}],
            [40,'Chic & Caos Hair Studio','Piazza Giorgione, 1a 31033 Castelfranco Veneto TV', {lat: 45.6733386, lng: 11.9272580}],
            [41,'Madel&Na','Via Brolo,16 31033 Castelfranco Veneto TV', {lat: 45.6562221, lng: 11.9651297}],
            [42,'Vanity Style','Via Centro, 6/a Fraz. Salvatronda 31033 Castelfranco Veneto TV', {lat: 45.6636815, lng: 11.9155972}],
            [43,'Salone Laura','Via Angaran, 58 31020 Castelminio di Resana TV', {lat: 45.6573458, lng: 11.9958436}],
            [44,'Time Color','Via Sanavalle,1/e 31030 Cison di Valmarino TV', {lat: 45.9677439, lng: 12.1516168}],
            [45,'Nuova Immagine','Via Sant\'Urbano, 27/a 31041 Cornuda TV', {lat: 45.8338975, lng: 12.0181486}],
            [46,'E Parrucchieri','Via Boschieri,60/a 31035 Crocetta del Montello TV', {lat: 45.8256421, lng: 12.0482844}],
            [47,'Acconciature Vale','Via Aldo Moro, 45 31022 Frescada di Preganziol TV', {lat: 45.6339067, lng: 12.2436944}],
            [48,'Salone Donatella','Via C. Battisti 64 31020 Frescada Preganziol TV', {lat: 45.6367595, lng: 12.2401692}],
            [49,'I Parrucchieri','Piazza della Repubblica 3/8 31021 Mogliano Veneto TV', {lat: 45.5580586, lng: 12.2514180}],
            [50,'Equipe 5504','Via Bergamo 56 31044 Montebelluna TV', {lat: 45.7682411, lng: 12.0512145}],
            [51,'Rossi Parrucchieri','Via Montegrappa,151 31044 Montebelluna TV', {lat: 45.7751399, lng: 12.0445940}],
            [52,'Look e Life','Via Villette,19/a 31040 Musano di Trevignano TV', {lat: 45.7331272, lng: 12.1043681}],
            [53,'Charme Parrucchieri','Via Sottana, 9 31038 Padernello TV', {lat: 45.6796309, lng: 12.1288411}],
            [54,'Elle Parrucchieri','Via G.Marconi, 11 31038 Paese TV', {lat: 45.6896371, lng: 12.1540405}],
            [55,'New Look… Specialisti del Colore','Via della Resistenza, 10 31038 Paese TV', {lat: 45.6773391, lng: 12.1656460}],
            [56,'Salone Giusy','Via Montello, 30 31038 Paese TV', {lat: 45.6816521, lng: 12.1610455}],
            [57,'Free Style','Via Roma 187 31040 Pederobba TV', {lat: 45.8765045, lng: 11.9506906}],
            [58,'Il Salotto di Anna','Via Onorevole Visentin, 8 31038 Postioma di Paese TV', {lat: 45.7165315, lng: 12.1516841}],
            [59,'Vanity Style','Via Postumia,23 31055 Quinto di Treviso TV', {lat: 45.6693322, lng: 12.1794346}],
            [60,'L\'Arte di Chiara','Via Camillo Benso Cavour,28 31048 S.Biagio di Callalta TV', {lat: 45.6755687, lng: 12.3426879}],
            [61,'Testa a Posto','Via Mons.Tognana 75/B 31055 S.Cristina-Quinto TV', {lat: 45.6517782, lng: 12.1336410}],
            [62,'Salone Miky','Via Brandolini 94 31053 Solighetto TV', {lat: 45.9097906, lng: 12.1726771}],
            [63,'Salone Rosa & Dania','Via Cendrole 48 31039 Spineda di Riese Pio X TV', {lat: 45.7499828, lng: 11.8836609}],
            [64,'Unika','Via Piva,108 31049 Valdobbiadene TV', {lat: 45.9016306, lng: 11.9984185}],
            [65,'Fashion Lady','Via Giorgione 26 31050 Vedelago TV', {lat: 45.6856513, lng: 12.0168068}],
            [66,'Stevanato Parrucchieri','Piazza 24 Maggio, 9 31050 Vedelago-Albaredo TV', {lat: 45.6609814, lng: 12.0087356}],
            [67,'Be Free','Via Mario Fiore,5/a 31050 Visnadello TV', {lat: 45.7613184, lng: 12.2519782}],
            [68,'Il Bello delle Donne','Via Venozzi 8 31040 Volpago del Montello TV', {lat: 45.7743488, lng: 12.1225267}],
            [69,'Blu Elettrico','Via Pomai 15 30035 Campocroce di Mirano VE', {lat: 45.4937106, lng: 12.0522893}],
            [70,'Salone Barbara','Via dei Martiri 9-11 30014 Cavarzere VE', {lat: 45.1368699, lng: 12.0811814}],
            [71,'Salone Antonella','Via Moglianese G. 122/B 30030 Gardigiano Scorze\' VE', {lat: 45.5628786, lng: 12.1960467}],
            [72,'Eterea','Via Stazione 22 30030 Maerne VE', {lat: 45.5167988, lng: 12.1514770}],
            [73,'Salone Betty','Piazza Iv Novembre 10 30020 Marcon VE', {lat: 45.5543521, lng: 12.2993285}],
            [74,'Salone Donatella','Via C. Rossarol 13/B 30175 Marghera VE', {lat: 45.4698588, lng: 12.2219753}],
            [75,'Parrucchiera Stefania','Via Miranese,6 30171 Mestre VE', {lat: 45.4921540, lng: 12.2353257}],
            [76,'Spazio Immagine','Via Goldoni 11/a 30174 Mestre VE', {lat: 45.5065745, lng: 12.2507150}],
            [77,'Diva','Via Bissolati 18/B 30170 Mestre-Venezia VE', {lat: 45.4873952, lng: 12.2457655}],
            [78,'Elegance','Via Roma,16 30020 Quarto D\'Altino VE', {lat: 45.5823913, lng: 12.3624752}],
            [79,'Anna Gloria Parrucchieri','Via Bigolo 4 30037 Scorze\' VE', {lat: 45.5858729, lng: 12.1328669}],
            [80,'Salone Asya','Via delle Stelle Alpine,32 36051 Creazzo VI', {lat: 45.5346123, lng: 11.4834672}],
            [81,'Barbara Acconciature','Via Gobette 11,31050 Carpenedo-Cavasagra Vedelago TV', {lat: 45.67523452331492, lng: 12.055421610793056}],
            [82,'Salone Bruno','Piazza Gen.Caviglia,20,31050 Vedelago Fraz.Cavasagra T', {lat: 45.66187443175421, lng: 12.054446973428151}],
            [83,'L\'Aurora','Via Desman 175/E,30036 S.Angelo di S.M.Sala VE', {lat: 45.52144699119588, lng: 12.015076582748144}],
        ];

        async function initMap() {
            const { Map } = await google.maps.importLibrary("maps");
            const myLatLng = { lat: 45.49307090505629, lng: 12.077862212712343 };
            const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

            // Short namespaces can be used.
            let map = new Map(document.getElementById("map"), {
                center: myLatLng,
                zoom: 12,
                mapId: 'mpaDNA'
            });

            // RICERCA MAPPA --- Create the search box and link it to the UI element.
            const input = document.getElementById("searchCity");
            const searchBox = new google.maps.places.SearchBox(input);

            // Bias the SearchBox results towards current map's viewport.
            map.addListener("bounds_changed", () => {
                searchBox.setBounds(map.getBounds());
            });

            let markers = [];

            let cityCircle = new google.maps.Circle ({
                strokeColor: "#43AA8D",
                strokeOpacity: 0.8,
                strokeWeight: 2,
                fillColor: "#43AA8D",
                fillOpacity: 0.35,
                map: map,
                center: myLatLng,
                radius: 0,
                zindex: 999,
                scale: 20,
                visible:true
            });
            searchBox.addListener("places_changed", () => {
                const places = searchBox.getPlaces();
                if (places.length == 0) {
                    return;
                }

                // Clear out the old markers.
                markers.forEach((marker) => {
                    marker.setMap(null);
                });
                markers = [];
                let marker;

                // For each place, get the icon, name and location.
                const bounds = new google.maps.LatLngBounds();
                places.forEach((place) => {
                    if (!place.geometry || !place.geometry.location) {
                        console.log("Returned place contains no geometry");
                        return;
                    }

                    let pin = document.createElement("img");
                    pin.src = "/themes/dna/assets/images/marker.png";
                    pin.width = 25;

                    marker = new AdvancedMarkerElement({
                        content: pin,
                        position: place.geometry.location,
                        map: map,
                    });
                    if (place.geometry.viewport) {
                        // Only geocodes have viewport.
                        bounds.union(place.geometry.viewport);
                    } else {
                        bounds.extend(place.geometry.location);
                    }

                    let new_lat_lng = { lat: place.geometry.location.lat(), lng: place.geometry.location.lng() }

                    $('#btn-cerca').click(function (){
                        // if (cityCircle){
                        //     cityCircle.setMap(null);
                        // }
                        let new_radius = $('#raggio_km').val();
                        let rad = new_radius * 1000;
                        cityCircle.setCenter(new_lat_lng);
                        cityCircle.setRadius(rad);
                    });
                });
                map.fitBounds(bounds);
            });

            let infowindow = new google.maps.InfoWindow();
            locations.forEach((item) => {
                let pin = document.createElement("img");
                pin.src = "/themes/dna/assets/images/marker.png";
                pin.width = 18;

                 let marker = new AdvancedMarkerElement({
                    content: pin,
                    position: item[3],
                    map: map,
                });

                google.maps.event.addListener(marker, 'click', function() {
                    map.panTo(item[3]);
                    infowindow.close();
                    infowindow.setContent(`<div id="infowindow">
                        <h5>${item[1]}</h5>
                        <p>${item[2]}</p>
                    </div>`);
                    infowindow.open({
                        anchor: marker,
                        map: map,
                    });
                    map.setZoom(16);
                });
            });

            // AL CLICK CAMBIA LA POSIZIONE DELLA LISTA IN HTML E AGGIUNGE CLASSE ACTIVE
            let city = document.querySelectorAll('.city');
            if (city) {
                city.forEach(function(el, key){
                    el.addEventListener('click', function () {
                        let position = {lat: parseFloat($(this).attr('data-lat')), lng: parseFloat($(this).attr('data-lng'))}
                        map.panTo(position);
                        map.setZoom(16);
                        el.classList.toggle("city-active");
                        city.forEach(function(ell, els){
                            if(key !== els) {
                                ell.classList.remove('city-active');
                            }
                        });
                    });
                });
            }
        }
        initMap();
    }
});
